<template>
  <div :class="formClass">
    <p class="font-semibold">{{ title }}</p>
    <div :class="{ warn: isError }" class="relative">
      <input
        @input="$emit('update:modelValue', $event.target.value)"
        @change="onChange"
        :oninput="oninput"
        :value="modelValue"
        :class="[inputClass, { 'p-invalid': isError }]"
        :placeholder="placeholder"
        :disabled="disabled"
        class="p-inputtext p-component w-full"
      />
      <small v-if="isError" class="p-error">{{ error }}</small>
    </div>
  </div>
</template>

<script>
export default {
  name: "Input",
  inheritAttrs: false,
  emits: ["update:modelValue"],
  props: {
    modelValue: [String, Number],
    isError: Boolean,
    error: String,
    title: String,
    disabled: Boolean,
    placeholder: String,
    formClass: String,
    inputClass: String,
    onChange: Function,
    oninput: Function
  }
};
</script>
